import { Accordion, AccordionDetails, AccordionSummary, Checkbox } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import { LegendItem, LegendCircle } from "components/LegendItem";
import icons from "enums/icons";
import CheckboxLabel from "../PreviousPaceModal/components/CheckboxLabel/CheckboxLabel";
import { filteredPeople } from "../PreviousPaceModal/PreviousPaceModal";

const CollapsableAssessments = ({
    person,
    shouldExpand,
    handleUpdateReports,
}: {
    person: filteredPeople[number];
    shouldExpand: boolean;
    handleUpdateReports: (checked: boolean, personId?: number, assessmentId?: number) => void;
}) => {
    const ContentHeader = () => {
        return (
            <LegendItem
                sx={{ mb: 0.5, fontSize: 16 }}
                icon={<LegendCircle size={11} color={person.color} />}
                label={person.name}
            />
        );
    };

    const ContentBody = () => {
        return (
            <>
                {person?.reports?.map((report) => {
                    const label = `${report.label} ${report.isCurrent ? "[Current]" : ""}`;
                    const disabled = person?.reports?.filter((r) => r.checked).length === 1;

                    return (
                        <CheckboxLabel
                            key={report.user_assessment_id}
                            sx={{ mb: 0.5, display: "block" }}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={report.checked}
                                    disabled={report.checked && disabled}
                                    onChange={(e) =>
                                        handleUpdateReports(e.target.checked, person.id, report.user_assessment_id)
                                    }
                                />
                            }
                            label={label}
                        />
                    );
                })}
            </>
        );
    };

    return (
        <Accordion
            sx={{
                boxShadow: "none",
                paddingRight: 0.5,
                "& .MuiButtonBase-root": { minHeight: "auto", "&.Mui-expanded": { minHeight: "auto" } },
                "& .MuiAccordionSummary-content": { margin: "0", "&.Mui-expanded": { margin: "0" } },
                "& .MuiAccordionDetails-root": { padding: 0 },
            }}
        >
            <AccordionSummary
                sx={{ padding: 0, margin: 0 }}
                expandIcon={<CustomIcon icon={icons.chevronDownThin} sx={{ fontSize: 12 }} />}
                id={`${person.id}`}
            >
                <ContentHeader />
            </AccordionSummary>
            <AccordionDetails>
                <ContentBody />
            </AccordionDetails>
        </Accordion>
    );
};

export default CollapsableAssessments;
